import ActionType from '../action-types';

const initialState = {
  loading: false,
  error: null,
  success: false,
  user: null,
  change_password: false
};

// eslint-disable-next-line default-param-last
const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.AUTH_START:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
        user: null,
        change_password: false
      };
    case ActionType.CLEAR_ERROR:
      return {
        ...state,
        error: null
      };
    case ActionType.AUTH_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        change_password: false,
        user: {
          id: action.payload.id,
          firstname: action.payload.firstname,
          lastname: action.payload.lastname,
          phone: action.payload.phone,
          status: action.payload.status,
          designation: action.payload.designation,
          profileImage: action.payload.profile_image,
          stationId: action.payload.stationId,
          staffId: action.payload.staffId,
          kinFirstname: action.payload.kinFirstname,
          kinLastname: action.payload.kinLastname,
          kinRelationship: action.payload.kinRelationship,
          kinPhonenumber: action.payload.kinPhone
        },
        success: true
      };
    case ActionType.STAFF_CHANGE_PASSWORD:
      return {
        ...state,
        loading: false,
        user: { id: action.payload },
        error: null,
        change_password: true,
        success: false
      };
    case ActionType.STAFF_CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        change_password: false
      };
    case ActionType.AUTH_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
        user: null,
        change_password: false,
        success: false
      };
    case ActionType.SIGNOUT_START:
      return {
        ...state,
        loading: true,
        error: null,
        user: null,
        success: false
      };
    case ActionType.SIGNOUT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        user: null,
        success: true
      };
    case ActionType.SIGNOUT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false
      };
    case ActionType.CURRENT_USER_START:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
        user: null
      };
    case ActionType.CURRENT_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: true,
        user: {
          id: action.payload.id,
          username: action.payload.username,
          first_name: action.payload.first_name,
          last_name: action.payload.last_name,
          phone: action.payload.phone
        }
      };
    case ActionType.CURRENT_USER_ERROR:
      return {
        ...state,
        loading: false,
        error: null,
        success: false,
        user: null
      };
    default:
      return state;
  }
};

export default authReducer;
